import React, { Suspense } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";

import { useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import { requestInstance } from "config/axios";
import { timeOfLogin } from "utils/sessiontimeout";

const LoginPage = React.lazy(() => import("pages/Auth"));
const Logout = React.lazy(() => import("pages/Logout"));
const ResetPassword = React.lazy(() => import("pages/ResetPassword"));

const Home = React.lazy(() => import("pages/Home"));
const NotFound = React.lazy(() => import("pages/NotFound"));
const Mock = React.lazy(() => import("pages/Mock"));

const TrackingList = React.lazy(() => import("pages/TrackingList"));

const CustomersList = React.lazy(() => import("pages/Customer"));
const UserList = React.lazy(() => import("pages/User"));
const UnitList = React.lazy(() => import("pages/Unit"));
const Contacts = React.lazy(() => import("pages/Contacts"));
const DeviceSoftWareUpdate = React.lazy(() =>
  import("pages/DeviceSoftwareUpdates")
);

const Report = React.lazy(() => import("pages/Report"));
const GenerateReport = React.lazy(() => import("pages/Report/generateReport"));

const Spinner = React.lazy(() => import("@components/Spinner"));

const { REACT_APP_AUTH_SERVICE_API_URL } = process.env;

const fetchAccessToken = (code) => {
  const payloadJSON = {
    authCode: code
  };
  // console.log("fetch access token", code);

  return requestInstance({
    url: `${REACT_APP_AUTH_SERVICE_API_URL}/auth/v1/token`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    method: "POST",
    data: JSON.stringify(payloadJSON)
  });
};

export default function RootRoute() {
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const code = searchParams?.get("code");
  // console.log("---log code", code);

  const onSuccess = (data) => {
    // console.log("-- on success", data);
    sessionStorage.setItem("access_token", data?.data?.token || "");
    sessionStorage.setItem("userId", data?.data?.userId);
    sessionStorage.setItem("name", data?.data?.name);
    // sessionStorage.setItem("roleId", data?.data?.roleId);
    sessionStorage.setItem("customerId", data?.data?.customerId);
    sessionStorage.setItem("timeoflogin", timeOfLogin());
    navigate("/bstracking/tracking");
  };
  const onError = (error) => {
    if (error) {
      navigate("/login");
      sessionStorage.clear();
    }
  };

  const { isLoading, data, isError } = useQuery(
    "get-token",
    () => fetchAccessToken(code),
    {
      onSuccess,
      onError,
      enabled: !!code
    }
  );

  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/login" />} />
      <Route
        path="/login"
        element={
          <Suspense fallback={<></>}>
            <LoginPage />
          </Suspense>
        }
      />
      <Route
        path="/logout"
        element={
          <Suspense fallback={<></>}>
            <Logout />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <Suspense fallback={<>Loading...</>}>
            <NotFound />
          </Suspense>
        }
      />
      <Route
        path="/mock"
        element={
          <Suspense fallback={<>Loading...</>}>
            <Mock />
          </Suspense>
        }
      />
      <Route
        path="/resetpassword"
        element={
          <Suspense fallback={<>Loading...</>}>
            <ResetPassword />
          </Suspense>
        }
      />
      <Route
        path="bstracking"
        element={
          <Suspense fallback={<>Loading...</>}>
            <PrivateOutlet>
              <Home />
            </PrivateOutlet>
          </Suspense>
        }
      >
        <Route
          path="tracking-list"
          element={
            <Suspense
              fallback={
                <>
                  <Spinner />
                </>
              }
            >
              {/* <GridData /> */}
            </Suspense>
          }
        />
        <Route
          path="tracking"
          element={
            <Suspense
              fallback={
                <>
                  <Spinner />
                </>
              }
            >
              <TrackingList />
            </Suspense>
          }
        />

        <Route
          path="customer"
          element={
            <Suspense
              fallback={
                <>
                  <Spinner />
                </>
              }
            >
              <CustomersList />
            </Suspense>
          }
        />
        <Route
          path="user"
          element={
            <Suspense
              fallback={
                <>
                  <Spinner />
                </>
              }
            >
              <UserList />
            </Suspense>
          }
        />
        <Route
          path="unit"
          element={
            <Suspense
              fallback={
                <>
                  <Spinner />
                </>
              }
            >
              <UnitList />
            </Suspense>
          }
        />
        <Route
          path="contacts"
          element={
            <Suspense
              fallback={
                <>
                  <Spinner />
                </>
              }
            >
              <Contacts />
            </Suspense>
          }
        />
        <Route
          path="device-software-update"
          element={
            <Suspense
              fallback={
                <>
                  <Spinner />
                </>
              }
            >
              <DeviceSoftWareUpdate />
            </Suspense>
          }
        ></Route>
        <Route
          path="report"
          element={
            <Suspense
              fallback={
                <>
                  <Spinner />
                </>
              }
            >
              <Report />
            </Suspense>
          }
        />
        <Route
          path="report/generatereport"
          element={
            <Suspense
              fallback={
                <>
                  <Spinner />
                </>
              }
            >
              <GenerateReport />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}

function PrivateOutlet({ children }) {
  const auth = useAuth();
  return auth ? children : <Navigate to="/login" />;
}

function useAuth() {
  if (sessionStorage.getItem("access_token")) return true;
  else return false;
}
